import { eventChannel } from 'redux-saga'
import { call, put, takeEvery, fork, take, select } from 'redux-saga/effects'

import auth from './auth'
// import analytics from './analytics'
import search from './search'
import users from './users'
import consultants from './consultants'
import settings from './settings'
import chat from './chat'
import * as api from 'api'
import {
  SAVE_CONSULTANT,
  SAVE_CONSULTANT_SUCCESS,
  SAVE_CONSULTANT_ERROR,
  UNSAVE_CONSULTANT,
  UNSAVE_CONSULTANT_SUCCESS,
  UNSAVE_CONSULTANT_ERROR,
  FETCH_SAVED_CONSULTANTS,
  FETCH_SAVED_CONSULTANTS_SUCCESS,
  FETCH_SAVED_CONSULTANTS_ERROR,
  CONTACT_CONSULTANT,
  CONTACT_CONSULTANT_SUCCESS,
  CONTACT_CONSULTANT_ERROR,
  SAVE_SEARCH_QUERY_SUCCESS,
  SAVE_SEARCH_QUERY_ERROR,
  SEARCH,
  COMPLETE_ONBOARDING,
  CUSTOMER_CONTACT,
  SEND_MESSAGE,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_ERROR,
  ROOM_MESSAGES,
  SUBSCRIBE_TO_MESSAGES,
  UNSUBSCRIBE_FROM_MESSAGES,
  VISIT,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from 'actionTypes'
import { isLoggedInSelector } from 'selectors'

function* saveConsultant({ id }) {
  try {
    yield call(api.saveConsultant, id)
    yield put({ type: SAVE_CONSULTANT_SUCCESS, id })
  } catch ({ message }) {
    yield put({ type: SAVE_CONSULTANT_ERROR, message })
  }
}

function* unsaveConsultant({ id }) {
  try {
    yield call(api.unsaveConsultant, id)
    yield put({ type: UNSAVE_CONSULTANT_SUCCESS, id })
  } catch ({ message }) {
    yield put({ type: UNSAVE_CONSULTANT_ERROR, message })
  }
}

function* fetchSavedConsultants() {
  try {
    const savedConsultants = yield call(api.fetchSavedConsultants)
    yield put({ type: FETCH_SAVED_CONSULTANTS_SUCCESS, savedConsultants })
  } catch ({ message }) {
    yield put({ type: FETCH_SAVED_CONSULTANTS_ERROR, message })
  }
}

function* contactConsultant({ id, message }) {
  try {
    yield call(api.contactConsultant, id, message)
    yield put({ type: CONTACT_CONSULTANT_SUCCESS, id, message })
  } catch ({ message }) {
    yield put({ type: CONTACT_CONSULTANT_ERROR, message })
  }
}

function* saveSearchQuery({ query, available, triggerNavigation }) {
  try {
    if (triggerNavigation && (query || available)) {
      yield call(api.saveSearch, query, available)
      yield put({ type: SAVE_SEARCH_QUERY_SUCCESS, query })
    }
  } catch ({ message }) {
    yield put({ type: SAVE_SEARCH_QUERY_ERROR, message })
  }
}

function* completeOnboarding() {
  yield call(api.completeOnboarding)
}

function* saveCustomerContact({ data }) {
  try {
    yield call(api.saveCustomerContact, data)
  } catch (e) {}
}

function* sendMessage({ roomId, message }) {
  try {
    yield call(api.sendMessage, roomId, message)
    yield put({ type: SEND_MESSAGE_SUCCESS, roomId, message })
  } catch ({ message: errorMessage }) {
    yield put({ type: SEND_MESSAGE_ERROR, roomId, message, errorMessage })
  }
}

function* subscribeToMessages({ roomId }) {
  const channel = eventChannel(api.subscribeToMessages(roomId))
  yield takeEvery(channel, function* newMessages(messages) {
    yield put({
      type: ROOM_MESSAGES,
      roomId,
      messages,
    })
  })
  yield take(
    action =>
      action.type === UNSUBSCRIBE_FROM_MESSAGES && action.roomId === roomId
  )
  channel.close()
}

function* visit({ page }) {
  const isLoggedIn = yield select(isLoggedInSelector)
  if (isLoggedIn) {
    yield call(api.visit, page)
  }
}

function* resetPassword({ email }) {
  try {
    yield call(api.resetPassword, email)
    yield put({ type: RESET_PASSWORD_SUCCESS })
  } catch ({ message }) {
    yield put({ type: RESET_PASSWORD_ERROR, message })
  }
}

function* saga() {
  if (process.env.NODE_ENV === 'production') {
    // yield fork(analytics)
  }
  yield fork(auth)
  yield fork(users)
  yield fork(search)
  yield fork(consultants)
  yield fork(settings)
  yield fork(chat)
  yield takeEvery(SAVE_CONSULTANT, saveConsultant)
  yield takeEvery(UNSAVE_CONSULTANT, unsaveConsultant)
  yield takeEvery(FETCH_SAVED_CONSULTANTS, fetchSavedConsultants)
  yield takeEvery(CONTACT_CONSULTANT, contactConsultant)
  yield takeEvery(SEARCH, saveSearchQuery)
  yield takeEvery(COMPLETE_ONBOARDING, completeOnboarding)
  yield takeEvery(CUSTOMER_CONTACT, saveCustomerContact)
  yield takeEvery(SEND_MESSAGE, sendMessage)
  yield takeEvery(SUBSCRIBE_TO_MESSAGES, subscribeToMessages)
  yield takeEvery(VISIT, visit)
  yield takeEvery(RESET_PASSWORD, resetPassword)
}

export default saga



// WEBPACK FOOTER //
// ./src/sagas/index.js